<template>
  <div>
    <a-card title="Totales" style="width: 300px">
    <a-row>
      <a-col v-bind="colOptions">
        Crédito Total
      </a-col>
      <a-col v-bind="colOptions">
          <b>
            $ {{creditos}}
          </b>
      </a-col>
    </a-row>
    <a-row>
      <a-col v-bind="colOptions">
        Debito Total
      </a-col>
      <a-col v-bind="colOptions">
          <b>
        $ {{debitos}}
          </b>
      </a-col>
    </a-row>
      <a-row v-if="diferencia">
        <a-col v-bind="colOptions">
          Diferencia
        </a-col>
        <a-col v-bind="colOptions">
            <b>
              $ {{diferencia}}
            </b>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['items'],
    mounted () {
      this.totales()
    },
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        creditos: 0,
        debitos: 0
      }
    },
    methods: {
      totales () {
        this.creditos = this.items.reduce((acc, curr) => {
          if (!JsUtils.isEmpty(curr.ammount_l_cre)) {
            return acc + parseFloat(curr.ammount_l_cre)
          }
        }, 0)
        this.debitos = this.items.reduce((acc, curr) => {
          if (!JsUtils.isEmpty(curr.ammount_l_deb)) {
            return acc + parseFloat(curr.ammount_l_deb)
          }
        }, 0)
      }
    },
    watch: {
      items: {
        handler: function (val, oldVal) {
          this.totales()
        },
        deep: true
      }
    },
    computed: {
      diferencia () {
        return this.debitos - this.creditos
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/Totales.vue